import { helpers } from '../../common/lib';
import getInitialState from '../get-initial-state';
import { actionTypes } from './actions';

const initialState = { ...getInitialState.list() };

export default function (state = { ...initialState }, action) {
  switch (action.type) {
    case actionTypes.ORGANISATION_ITEM_CLEAR: {
      return { ...state, item: null };
    }
    case actionTypes.ORGANISATION_ITEM_SET: {
      const { organisation } = action.payload;
      return { ...state, item: organisation };
    }
    case actionTypes.ORGANISATION_ITEM_UPDATE: {
      const { organisation } = action.payload;
      const { item } = state;
      return { ...state, item: { ...item, ...organisation } };
    }
    case actionTypes.ORGANISATIONS_GET_REQUEST: {
      return { ...initialState };
    }
    case actionTypes.ORGANISATIONS_GET_SUCCESS: {
      const { byId, data } = action.payload;
      return { ...state, byId, data };
    }
    case actionTypes.ORGANISATION_PATCH_SUCCESS: {
      const { organisation } = action.payload;
      return helpers.getListItemReducer(state, organisation);
    }
    default: {
      return state;
    }
  }
}
